module.exports = __webpack_public_path__ + "img/michael-pro.6f51eb89.jpg";